import { useTranslation } from "react-i18next";
import type { AnalysisUsageRef } from "@repo/shared";
import { ChipList } from "@h2j-data-team/ui";

interface UsageRefBadgesProps {
  refs: AnalysisUsageRef[];
  sheetTitles: Map<string, string | null>;
  showContext?: boolean;
}

/** Where an item is used: one chip per object — title, type, and the sheet it sits on. */
export function UsageRefBadges({ refs, sheetTitles, showContext = false }: UsageRefBadgesProps) {
  const { t } = useTranslation("analyses");

  const items = refs.map((ref, i) => {
    const sheetTitle = sheetTitles.get(ref.objectId);
    const label = [
      `${ref.objectTitle || t("usageRefs.untitled")} (${ref.objectType}${
        showContext && ref.context ? ` · ${ref.context}` : ""
      })`,
      // undefined: the reference is not a screen object (a master item) — no sheet to name.
      sheetTitle === undefined ? null : (sheetTitle ?? t("usageRefs.noSheet")),
    ]
      .filter(Boolean)
      .join(" · ");
    return { id: String(i), label, hint: label };
  });

  return <ChipList aria-label={t("usageRefs.label")} items={items} />;
}
